<script>
import { BModal, VBTooltip } from 'bootstrap-vue';
import { Confirm } from '../../services/Confirm';
import Integrations from '../../mixins/integrations';

export default {
  components: {
    BModal,
  },

  directives: {
    'b-tooltip': VBTooltip,
  },

  mixins: [Integrations],

  created () {
    Bus.$on('fieldsRetrieved', (fields) => (this.fields = fields));
  },

  data: () => ({
    fields: [
      //
    ],

    config: {
      origin: '',
      identifier: '',
      multiple: true,
      json: [
        {
          key: '',
          identifier: '',
        },
      ],
    },

    integration: {
      id: null,
      name: 'custom',
    },
  }),

  methods: {
    addRow () {
      const form = {
        key: '',
        identifier: '',
      };

      this.config.json.push(form);
    },

    handleSave () {
      this.save();

      this.$nextTick(() => this.close());
    },

    handleConfig (token) {
      if (token && token.config) {
        this.config = token.config;

        this.integration.id = token.id;

        return;
      }

      this.config = {
        identifier: '',
        multiple: true,
        json: [
          {
            key: '',
            identifier: '',
          },
        ],
      };

      this.integration.id = null;
    },

    deleteRow (index) {
      this.$delete(this.config.json, index);
    },

    open (token = null) {
      this.handleConfig(token);

      this.$refs['modal-custom-hook-integration'].show();
    },

    close () {
      this.$refs['modal-custom-hook-integration'].hide();
    },

    async destroy (token, index) {
      const text = this.__('Esta ação não poderá ser desfeita!');

      if (! await Confirm(this.__('Deseja excluir?'), text)) {
        return;
      }

      this.$http.delete(`/integration/config/${token.id}`)
        .then(() => this.integrations.splice(index, 1));
    },
  },
};
</script>

<template>
  <div
    class="custom-hook"
  >
    <label
      class="d-flex align-items-center"
    >
      {{ __('Configure Webhooks customizados') }}

      <div
        class="mt-n4 ml-auto"
      >
        <button
          type="button"
          @click="open"
          class="btn btn-primary"
        >
          <IconPlus />
        </button>
      </div>
    </label>

    <div
      class="custom-hook__integrations"
      v-if="integrations && integrations.length > 0"
    >
      <label
        class="lg"
        v-text="__('Webhooks criados')"
      />

      <div
        :key="index"
        class="custom-hook__list"
        v-for="(token, index) of integrations"
      >
        <div
          class="custom-hook__item"
          :class="{ 'integrations__item--borderless': index === 0 }"
        >
          <span
            class="custom-hook__item-key custom-hook__item-key--json"
          >
            <span
              v-text="__('Identificador:')"
              class="custom-hook__item-key-title"
            />

            <span
              v-text="token.config.identifier"
              class="custom-hook__item-value"
            />
          </span>

          <span
            class="custom-hook__item-key"
          >
            <span
              v-text="__('Link:')"
              class="custom-hook__item-key-title"
            />

            <span
              class="custom-hook__item-value"
              v-text="`https://app.salesflowcrm.com.br/hook/custom/${token.hashid}`"
            />
          </span>
        </div>

        <a
          href="#"
          @click.prevent="open(token)"
          class="ml-3 custom-hook__button"
          v-b-tooltip.bottomleft="__('Editar Integração')"
        >
          <IconPencilFilled
            :size="18"
          />
        </a>

        <a
          href="#"
          class="ml-3 custom-hook__button"
          @click.prevent="destroy(token, index)"
          v-b-tooltip.bottomleft="__('Remover Integração')"
        >
          <IconTrash/>
        </a>
      </div>
    </div>

    <BModal
      size="lg"
      hide-header="hide-header"
      hide-footer="hide-footer"
      id="modal-custom-hook-integration"
      ref="modal-custom-hook-integration"
      modal-class="modal-no-header-no-footer"
    >
      <button
        class="close"
        type="button"
        @click="close"
        aria-label="Close"
      >
      <span aria-hidden="true">×</span>
      </button>

      <h4
        v-text="__('Novo webhook customizado')"
        class="modal-title align-items-center text-center"
      />

      <form
        :key="integration.id"
        @submit.prevent="handleSave"
      >
      <div v-if="!loading"
        class="lead-filter pr-20px">
          <div
            class="custom-hook__row custom-hook__row--identifier"
          >
            <div
              class="custom-hook__columns-column"
            >
              <label
                class="lg"
                v-text="__('Identificador da conversão')"
              />

              <p>
                <input
                  type="text"
                  required="required"
                  class="form-control"
                  v-model="config.identifier"
                >
              </p>
            </div>
          </div>

          <div
            class="custom-hook__row custom-hook__row--identifier"
          >
            <div
              class="custom-hook__columns-column"
            >
              <label
                class="lg"
                v-text="__('Origem da conversão')"
              />

              <p>
                <input
                  type="text"
                  required="required"
                  class="form-control"
                  v-model="config.origin"
                >
              </p>
            </div>
          </div>
          <div
            :key="index"
            class="custom-hook__row"
            v-for="(row, index) in config.json"
          >
            <div
              class="custom-hook__columns"
            >
              <div
                class="custom-hook__columns-column"
              >
                <label
                  class="lg"
                  v-text="__('Valor')"
                />

                <p>
                  <input
                    type="text"
                    v-model="row.key"
                    required="required"
                    class="form-control"
                    pattern="^[a-zA-Z0-9_.-.{.}.*]+$"
                    title="Utilize somente números, letras, pontos (.) e hífens (-) para definir a propriedade"
                  >
                </p>
              </div>

              <div
                class="custom-hook__columns-column"
              >
                <label
                  class="lg"
                  v-text="__('Identificador')"
                />

                <p>
                  <TenantCustomFieldDropdown
                    :fields="fields"
                    :selected="row.identifier"
                    @select="row.identifier = $event"
                    :key="`${row.identifier}-${index}`"
                  />
                </p>
              </div>
            </div>

            <a
              href="#"
              class="ml-3"
              @click.prevent="deleteRow(index)"
              v-b-tooltip.bottomleft="__('Remover linha')"
            >
              <IconTrash
                :size="18"
              />
            </a>
          </div>
          <div class="form-group">
            <a class="add"
              href="#"
              @click="addRow()"
            ><i class="fa fa-plus mr-2" />{{ __("Adicionar condição") }}</a>
          </div>
        </div>
        <div class="form-group">
          <hr>
        </div>
        <div class="modal-footer default-modal-footer" >
          <button
            type="submit"
            :disabled="false"
            class="salesflow-btn salesflow-btn-secondary f-w-500">
            <span v-text="__('Salvar')"/>
          </button>
        </div>
      </form>
    </BModal>
  </div>
</template>

<style lang="scss" scoped>
  @import '../../../sass/_variables';
  @import '../../../sass/mixins';

  .add{
    font-weight: 400 !important;
    color: var(--salesflow-primary) !important;
    text-decoration: underline !important;
    font-size: 12px !important;
  }
  .lead-filter {
    height: 426px;
    overflow-y: scroll;
    padding: 8px;

    select.form-control {
      option {
        @include salesflow-subtitle($color: $salesflow-font-dark);
      }
    }
  }

  .custom-hook {
    &__row {
      display: flex;
      align-items: center;

        &--identifier {
          width: calc(100% - 33px);
        }
    }

    &__columns {
      display: flex;
      width: calc(100% - 12px);

      & > :last-child {
        margin-left: 12px;
      }

      &-column {
        flex: 1;
      }
    }

    &__integrations {
      flex-flow: column nowrap;
    }

    &__item {
      flex-grow: 1;
      display: flex;
      padding: 8px 0px;
      align-items: center;
      justify-content: space-between;
      border-top: 1px solid #dee2e6;

      &--borderless {
        border-top: none;
      }

      &-key,
      &-secret {
        flex: 1;
        font-size: 12px;
        color: $gray-light;
        padding: 2px 0 1px;

        &-title {
          font-size: 12px;
          color: $gray-dark;
          margin-right: 2px;
        }

        &--json {
          overflow: auto;
          max-height: 21px;
        }
      }
    }

    &__title {
      font-size: 1rem;
      font-weight: 600;
      line-height: 14px;
      color: $gray-dark;
    }

    &__list {
      display: flex;
      align-items: center;
    }
  }
</style>
